// <s-sticky-buy> — mobile buy bar that slides up once the main buy form has scrolled above the viewport, and hides again when it or the closing CTA is in view.
class StickyBuy extends HTMLElement {
  #observer = null;
  #states = new Map();

  connectedCallback() {
    const selectors = (this.dataset.watch || '').split(',').map((s) => s.trim()).filter(Boolean);
    const targets = selectors.flatMap((selector) => Array.from(document.querySelectorAll(selector)));
    if (!targets.length) return;
    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        // Visible, or still below the viewport (not reached yet), both mean the bar should stay hidden.
        const blocking = entry.isIntersecting || entry.boundingClientRect.top > 0;
        this.#states.set(entry.target, { blocking, above: !entry.isIntersecting && entry.boundingClientRect.bottom < 0 });
      }
      this.#update(targets);
    });
    for (const target of targets) this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #update(targets) {
    const [buyForm, ...others] = targets;
    const buyState = this.#states.get(buyForm);
    const passedBuyForm = Boolean(buyState?.above);
    const otherVisible = others.some((target) => {
      const state = this.#states.get(target);
      return state && state.blocking && !(state.above) && this.#isOnScreen(target);
    });
    this.toggle(passedBuyForm && !otherVisible);
  }

  #isOnScreen(target) {
    const rect = target.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  toggle(show) {
    if (show) {
      this.setAttribute('data-visible', '');
      this.removeAttribute('inert');
    } else {
      this.removeAttribute('data-visible');
      this.setAttribute('inert', '');
    }
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', StickyBuy);
